module.exports = __webpack_public_path__ + "img/logo_app.01583609.png";